const HomeView = () =>
  import(/* webpackChunkName: "HomeView" */ "./HomeView.vue");

export default {
  name: "首页",
  path: "/",
  component: HomeView,
  meta: {show:true,},
};
